import React from 'react';
import Pagination from 'components/Pagination';
import PageLoader from 'components/PageLoader';
import { ApplicationStatus } from 'searchality-data';
import ApplicationsFillters from '../../components/ApplicaitonsFilters';
import ApplicationCard from 'components/ApplicationCard';
import { useNavigate } from 'react-router-dom';
import {
  teacherApplicationsApi,
  useGetApplicationsQuery,
} from 'api/teacherApplications.api';
import useAppDispatch from 'hooks/useAppDispatch';
import ApplicationEmptyState from '../../components/ApplicationEmptyState';
import { useParams } from 'hooks/useParams';
import useAppSelector from 'hooks/useAppSelector';
import authSelectors from 'store/selectors/auth.selectors';
import ApplicationsPaginationInfo from '../../components/ApplicationsPaginationInfo';

const initialParams = {
  $limit: 6,
  $populate: ['vacancy', 'vacancy.schools'],
  $where: {
    status: {
      $in: [
        ApplicationStatus.SUBMITTED,
        ApplicationStatus.IN_PROCESS,
        ApplicationStatus.DRAFT,
        ApplicationStatus.INFORMATION_REQUESTED,
        ApplicationStatus.INFORMATION_SUBMITTED,
      ],
    },
  },
};

const ActiveVacancies: React.FC = () => {
  const dispatch = useAppDispatch();

  const { _id: id } = useAppSelector(authSelectors.selectUser);

  const { params, sortBy, filterBy, changeCurrentPage, resetFilters } =
    useParams(initialParams);

  const { data, isLoading } = useGetApplicationsQuery({ id, params });

  const navigate = useNavigate();

  const { $where, $sort } = params;

  if (isLoading) {
    return <PageLoader />;
  }

  const { items: applications, ...pagination } = data;

  return (
    <div className="applications">
      <ApplicationsFillters
        onFilter={filterBy}
        filteredBy={$where}
        onReset={resetFilters}
        filterParams={initialParams}
      />
      <ApplicationsPaginationInfo
        limit={0}
        pagination={pagination}
        onSort={sortBy}
        sortedBy={$sort}
      />
      {isLoading || !applications ? (
        <PageLoader />
      ) : applications?.length > 0 ? (
        <ul>
          {applications.map((application) => (
            <ApplicationCard
              key={application?.vacancy._id}
              cardInformation={{
                status: application.status,
                positionTitle: application.vacancy.positionTitle,
                subjectGradeLevel: application.vacancy.subjectGradeLevel,
                school: application.vacancy.schools
                  ?.map((school) => school.name)
                  .join(', '),
                date: application.appliedAt ?? application.createdAt,
              }}
              onClick={() => {
                dispatch(teacherApplicationsApi.util.resetApiState());
                navigate(`../${application._id}`);
              }}
            />
          ))}
        </ul>
      ) : (
        <ApplicationEmptyState />
      )}
      {pagination?.totalPages > 1 && (
        <Pagination {...pagination} onChange={changeCurrentPage} />
      )}
    </div>
  );
};

export default ActiveVacancies;
